// Input with an optional leading icon and optional trailing slot (auth pages).
export function IconField({ icon, right, className = '', ...props }) {
  return (
    <div className="relative">
      {icon && <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-white/50">{icon}</span>}
      <input
        className={`w-full rounded-xl border border-white/20 bg-white/10 py-2.5 text-white placeholder:text-white/40
          transition focus:border-brand-light focus:bg-white/15 focus:outline-none focus:ring-2 focus:ring-brand-light/40
          ${icon ? 'pl-10' : 'pl-3'} ${right ? 'pr-10' : 'pr-3'} ${className}`}
        {...props}
      />
      {right && <span className="absolute right-2.5 top-1/2 -translate-y-1/2">{right}</span>}
    </div>
  );
}

export const EyeIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M2 10s3-5 8-5 8 5 8 5-3 5-8 5-8-5-8-5z" strokeLinecap="round" strokeLinejoin="round" /><circle cx="10" cy="10" r="2.2" />
  </svg>
);

export const EyeOffIcon = () => (
  <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
    <path d="M4 4l12 12M8.5 8.7A2.2 2.2 0 0010 12a2.2 2.2 0 001.9-1.1M6 6.4C3.6 7.7 2 10 2 10s3 5 8 5c1.2 0 2.3-.3 3.3-.7M9 5.1c.3 0 .7-.1 1-.1 5 0 8 5 8 5s-.6 1-1.7 2.1" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
